<ng-container>
  <span [ngClass]="{'mobile-visible-only' : onlyMobileVisibility}"    [style.font-size]="fontSize">{{ horse?.horseName }}</span>
</ng-container>
<span *ngIf="horse?.isHorseNamed"
      class="sireAndDam"
       [style.font-size]="fontSize"
      [ngClass]="{
       'text-gray': horse?.isHorseNamed,
       'mobile-visible-only': onlyMobileVisibility
     }">
  <br />
  {{ horse?.sire }} x {{ horse?.dam }}
</span>
